// extracted by mini-css-extract-plugin
export default {"wrapper":"DownloadFiles_wrapper__Ie3nE","heading":"DownloadFiles_heading__v+56u","body":"DownloadFiles_body__GV2Ka"};